var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79832 5.40808L4.35939 3.99996L6.79832 2.59183C6.87306 2.54868 6.89866 2.45312 6.85551 2.3784L6.80343 2.28819C6.76027 2.21345 6.66471 2.18785 6.58999 2.231L4.15106 3.63911V0.822876C4.15106 0.736587 4.08109 0.666626 3.99481 0.666626H3.89064C3.80435 0.666626 3.73439 0.736587 3.73439 0.822876V3.63911L1.29546 2.231C1.22072 2.18785 1.12516 2.21346 1.08202 2.28819L1.02994 2.3784C0.986785 2.45314 1.0124 2.5487 1.08712 2.59183L3.52606 3.99996L1.08712 5.40808C1.01238 5.45124 0.986785 5.5468 1.02994 5.62152L1.08202 5.71173C1.12517 5.78647 1.22073 5.81207 1.29546 5.76892L3.73439 4.36081V7.17704C3.73439 7.26333 3.80435 7.33329 3.89064 7.33329H3.99481C4.08109 7.33329 4.15106 7.26333 4.15106 7.17704V4.36081L6.58999 5.76892C6.66473 5.81207 6.76029 5.78646 6.80343 5.71173L6.85551 5.62152C6.89866 5.54678 6.87305 5.45122 6.79832 5.40808Z",
    fill: "#E60000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4603_8031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 6,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79832 5.40808L4.35939 3.99996L6.79832 2.59183C6.87306 2.54868 6.89866 2.45312 6.85551 2.3784L6.80343 2.28819C6.76027 2.21345 6.66471 2.18785 6.58999 2.231L4.15106 3.63911V0.822876C4.15106 0.736587 4.08109 0.666626 3.99481 0.666626H3.89064C3.80435 0.666626 3.73439 0.736587 3.73439 0.822876V3.63911L1.29546 2.231C1.22072 2.18785 1.12516 2.21346 1.08202 2.28819L1.02994 2.3784C0.986785 2.45314 1.0124 2.5487 1.08712 2.59183L3.52606 3.99996L1.08712 5.40808C1.01238 5.45124 0.986785 5.5468 1.02994 5.62152L1.08202 5.71173C1.12517 5.78647 1.22073 5.81207 1.29546 5.76892L3.73439 4.36081V7.17704C3.73439 7.26333 3.80435 7.33329 3.89064 7.33329H3.99481C4.08109 7.33329 4.15106 7.26333 4.15106 7.17704V4.36081L6.58999 5.76892C6.66473 5.81207 6.76029 5.78646 6.80343 5.71173L6.85551 5.62152C6.89866 5.54678 6.87305 5.45122 6.79832 5.40808Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4603_8031)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterix);
export default __webpack_public_path__ + "static/media/asterix.b1c2a028be9048eaf92f786a8e8edd60.svg";
export { ForwardRef as ReactComponent };